import { useState } from "react";
import ReactQuill from "react-quill-new";
import { Card, CardBody, Col, Row } from "reactstrap";
import { standardQuillText } from "../../../../Data/Miscellaneous/Editor";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { StandardEditorTitle } from "../../../../Utils/Constants";

export default function StandardEditor() {
  const [value, setValue] = useState(standardQuillText);
  return (
    <Row>
      <Col sm={12}>
        <Card>
          <CommonCardHeader title={StandardEditorTitle} />
          <CardBody>
            <ReactQuill value={value} onChange={setValue} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
